import {
    post
} from './request'

/** 获得分页列表 */
export const getPcIndex = data => post('/index/pc_list', data)
export const getPcIndexEwm = data => post('/index/ewm_list', data)
export const getPcIndexEwm2 = data => post('/index/quick_entry_list', data)
export const getWebsitInfo = data => post('/index/basic_detail', data)
// 行业概况列表接口
export const getHangYeGaiKuang = data => post('/index/industry_list', data)
/** 路况信息 */
export const getLukuangXinxi = data => post('/index/road_list', data)